import {AGENT} from '@/constants/usersTypes'
const AccountPartnerResumesBasePage = () => import(/* webpackChunkName: "account-partner-page" */ '@/views/Account/partner/AccountPartnerResumesBasePage')
const AccountPartnerResumesBaseResumesPage = () => import(/* webpackChunkName: "account-partner-page" */ '@/views/Account/partner/AccountPartnerResumesBaseResumesPage')
const AccountPartnerResumesBaseOnInteractionsPage = () => import(/* webpackChunkName: "account-partner-page" */ '@/views/Account/partner/AccountPartnerResumesBaseOnInteractionsPage')

const AccountResumeCardPage = () => import(/* webpackChunkName: "account-page" */ '../views/Account/AccountResumeCardPage')

const AccountStatisticsPage = () => import(/* webpackChunkName: "account-statistics-page" */ '@/views/Account/AccountStatisticsPage')


export default [{
  path: 'agent',
  name: 'account-agent',
  meta: {
    requiredUserTypes: [AGENT]
  },
  redirect: 'agent/resumes-base'
}, {
  path: 'agent/resumes-base',
  name: 'account-agent-resumes-base',
  component: AccountPartnerResumesBasePage,
  redirect: () => {
    return 'agent/resumes-base/resumes'
  },
  meta: {
    requiredUserTypes: [AGENT]
  },
  children: [{
    path: 'resumes',
    name: 'account-agent-resumes-base-resumes',
    component: AccountPartnerResumesBaseResumesPage
  }, {
    path: 'on-interaction',
    name: 'account-agent-resumes-base-on-interaction',
    component: AccountPartnerResumesBaseOnInteractionsPage
  }]
}, {
  path: 'agent/resumes-base/resumes/:resumeId',
  name: 'account-agent-resumes-base-resume',
  component: AccountResumeCardPage,
  meta: {
    requiredUserTypes: [AGENT]
  }
}, {
  path: 'agent/statistic',
  name: 'account-agent-statistic',
  component: AccountStatisticsPage,
  meta: {
    requiredUserTypes: [AGENT]
  },
}]
